import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/index.css'
import { App } from './App'
import { backendConfig } from './lib/env'
import { createBackend } from './lib/backend'
import { SessionProvider } from './lib/session'
import { ToastProvider } from './components/Toast'
import { ThemeProvider } from './lib/theme'

const backend = createBackend(backendConfig)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <SessionProvider backend={backend} config={backendConfig}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </SessionProvider>
    </ThemeProvider>
  </StrictMode>,
)
